import { Languages } from 'lucide-react'
import { useTranslation } from '../i18n/LanguageContext'

interface LanguageSelectorProps {
  variant?: 'pill' | 'header' | 'ribbon' | 'compact'
  className?: string
}

export function LanguageSelector({ variant = 'header', className = '' }: LanguageSelectorProps) {
  const { lang, setLang } = useTranslation()

  if (variant === 'compact') {
    return (
      <button
        type="button"
        onClick={() => setLang(lang === 'en' ? 'hi' : 'en')}
        className={`inline-flex items-center gap-1 rounded-xl border border-stone-200/90 bg-white/95 px-2.5 py-1.5 text-xs font-bold text-stone-700 shadow-sm transition-all hover:border-emerald-300 hover:text-emerald-800 active:scale-95 ${className}`}
        aria-label="Toggle language"
        title={lang === 'en' ? 'Switch to Hindi (हिंदी)' : 'Switch to English'}
      >
        <Languages className="h-3.5 w-3.5 text-emerald-600" />
        <span className="text-[11px] font-extrabold tracking-wide text-emerald-950">
          {lang === 'en' ? 'हिंदी' : 'Eng'}
        </span>
      </button>
    )
  }

  if (variant === 'ribbon') {
    return (
      <div className={`inline-flex items-center gap-1.5 text-xs ${className}`}>
        <Languages className="h-3.5 w-3.5 text-emerald-300" />
        <div className="inline-flex rounded-lg bg-emerald-950/60 p-0.5 border border-emerald-700/60 shadow-inner">
          <button
            type="button"
            onClick={() => setLang('en')}
            className={`rounded-md px-2 py-0.5 text-[11px] font-semibold transition-all ${
              lang === 'en'
                ? 'bg-emerald-500 text-emerald-950 shadow-sm font-bold'
                : 'text-emerald-200 hover:text-white'
            }`}
          >
            English
          </button>
          <button
            type="button"
            onClick={() => setLang('hi')}
            className={`rounded-md px-2 py-0.5 text-[11px] font-semibold transition-all ${
              lang === 'hi'
                ? 'bg-amber-400 text-amber-950 shadow-sm font-bold'
                : 'text-emerald-200 hover:text-white'
            }`}
          >
            हिंदी
          </button>
        </div>
      </div>
    )
  }

  return (
    <div
      className={`inline-flex items-center rounded-xl border border-stone-200/90 bg-stone-100/90 p-1 shadow-sm ${className}`}
      role="group"
      aria-label="Language selection"
    >
      <Languages className="ml-1 mr-1 h-3.5 w-3.5 text-stone-500" />
      <button
        type="button"
        onClick={() => setLang('en')}
        className={`rounded-lg px-2.5 py-1 text-xs font-semibold transition-all ${
          lang === 'en'
            ? 'bg-white text-stone-900 shadow-sm font-bold'
            : 'text-stone-600 hover:text-stone-900'
        }`}
      >
        English
      </button>
      <button
        type="button"
        onClick={() => setLang('hi')}
        className={`rounded-lg px-2.5 py-1 text-xs font-semibold transition-all ${
          lang === 'hi'
            ? 'bg-emerald-700 text-white shadow-sm font-bold'
            : 'text-stone-600 hover:text-stone-900'
        }`}
      >
        हिंदी
      </button>
    </div>
  )
}
